import { IconNameV2 } from 'common/icon/iconV2.js';
import { Reference } from 'common/reference/reference.js';
import { SummaryItem } from 'components.modules.gen/category-summary/item.js';
import { StatusRating } from 'utilities/status/status-rating.js';
import { IntegrationsConditionsType } from './types.js';

export interface IPollenData {
  level: string;
  type: string;
  icon: IconNameV2;
  status?: StatusRating;
}

export type PollenProps = IntegrationsConditionsType<{
  pollenLevels?: IPollenData;
}>;

export const Pollen = ({ pollen }: { pollen?: PollenProps }) => {
  if (pollen) {
    const { pollenLevels, displayEndOfSeasonMessage, endOfSeasonMessage, sponsorImage, sponsorURL, tagline } = pollen;

    if (displayEndOfSeasonMessage) {
      if (endOfSeasonMessage) {
        return (
          <SummaryItem
            icon={pollenLevels?.icon ?? 'pollen-risk'}
            dataModule={'pollen-content'}
            content={[endOfSeasonMessage]}
          />
        );
      }
      return null;
    } else {
      if (pollenLevels) {
        const { level, type, status } = pollenLevels;
        return (
          <SummaryItem
            icon={pollenLevels.icon ?? 'pollen-risk'}
            dataModule={'pollen-content'}
            title={'Pollen Forecast'}
            subTitle={[{ text: level, state: status }]}
            content={[`${type}`]}
          >
            <Reference image={sponsorImage} text={tagline} url={sponsorURL} classes="u-mT-xs u-mB-xs" />
          </SummaryItem>
        );
      }
      return null;
    }
  }
  return null;
};
